import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import { CoreUtils } from '@nhl/nhl-breakaway-ui';

import commonMessages from '~/core/commonMessages';

import { LandingGame } from '../../types';

import CompareHeader from './components/header/CompareHeader';
import PlayerCompare from './components/playerCompare/PlayerCompare';

import { DetailContainer, PlayersToWatchContainer } from './styles';

type Props = {
    game: LandingGame;
};

const PlayersToWatch: FC<Props> = ({ game }) => {
    const teamLeaderData = game?.matchup?.skaterComparison?.leaders?.filter(
        (leader) => leader.awayLeader && leader.homeLeader
    );
    const playersToWatchMessage = (
        <FormattedMessage
            description="Displays a teams leaders in points, goals, assists"
            defaultMessage="Players to Watch"
        />
    );
    return teamLeaderData?.length ? (
        <PlayersToWatchContainer>
            <CompareHeader message={playersToWatchMessage} game={game} />

            <DetailContainer>
                {teamLeaderData.map((teamLeader) => (
                    <PlayerCompare
                        key={teamLeader.category}
                        awayLeader={teamLeader.awayLeader}
                        homeLeader={teamLeader.homeLeader}
                        accessorField="value"
                        accessorLabel={teamLeader.category}
                        game={game}
                        title={
                            <CoreUtils.SafeFormattedMessage
                                message={commonMessages.statsDescriptions.long[teamLeader.category]}
                            />
                        }
                    />
                ))}
            </DetailContainer>
        </PlayersToWatchContainer>
    ) : null;
};

export default PlayersToWatch;
